export default {
  title: "Plantillas de cálculo",
  filter: {
    name: "Nombre de la plantilla",
    namePlaceholder: "Por favor ingrese el nombre de la plantilla",
    type: "Tipo de plantilla",
    typePlaceholder: "Por favor seleccione el tipo de plantilla",
  },
  table: {
    name: "Nombre de la plantilla",
    type: "Tipo",
    createdAt: "Creado el",
    actions: "Acciones",
    single: "Cálculo individual",
    batch: "Cálculo por lotes",
  },
  action: {
    edit: "Editar nombre",
    use: "Usar",
  },
  modal: {
    editTitle: "Editar nombre de la plantilla",
    nameLabel: "Nombre de la plantilla",
    namePlaceholder: "Por favor ingrese el nombre de la plantilla",
    nameRequired: "Por favor ingrese el nombre de la plantilla",
  },
  deleteConfirm: {
    title: "Eliminar plantilla",
    content: "¿Está seguro de que desea eliminar esta plantilla?",
  },
  message: {
    fetchFailed: "Error al obtener la lista de plantillas",
    updateSuccess: "Nombre de la plantilla actualizado con éxito",
    updateFailed: "Error al actualizar",
    deleteSuccess: "Plantilla eliminada con éxito",
  },
};
